// extracted by mini-css-extract-plugin
export default {"home":"SchoolifyContainer1_home__yoqPa"};